var map = {
	"./AgeasLogoForUnderwriterSelection.png": 789,
	"./AllianzLogoForUnderwriterSelection.png": 790,
	"./CatlinLogoForUnderwriterSelection.png": 791,
	"./ChaucerLogoForUnderwriterSelection.png": 792,
	"./EridgeLogoForUnderwriterSelection.png": 793,
	"./EridgeSelectLogoForUnderwriterSelection.png": 794,
	"./FirstSelectLogoForUnderwriterSelection.png": 795,
	"./FirstUnderwritingLogoForUnderwriterSelection.png": 796,
	"./GraniteLogoForUnderwriterSelection.png": 797,
	"./HavenLogoForUnderwriterSelection.png": 798,
	"./KGMLogoForUnderwriterSelection.png": 799,
	"./KineticLogoForUnderwriterSelection.png": 800,
	"./LVLogoForUnderwriterSelection.png": 801,
	"./MarkerstudyLogoForUnderwriterSelection.png": 802,
	"./MulsanneLogoForUnderwriterSelection.png": 803,
	"./PenUnderwritingLogoForUnderwriterSelection.png": 804,
	"./ServiceLogoForUnderwriterSelection.png": 805,
	"./SomersetBridgeInsuranceServicesLimitedLogoForUnderwriterSelection.png": 806,
	"./SouthernRockLogoForUnderwriterSelection.png": 807,
	"./TowergateLogoForUnderwriterSelection.png": 808,
	"./WatfordLogoForUnderwriterSelection.png": 809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 302;